import { Button, Flex, Link, Text } from '@chakra-ui/react';
import { CustomLinkIcon } from '../../../../../theme/icons/CustomLinkIcon';
import { HIGHLIGHT_COLOR } from './GoogleExpressivePassPreview';

interface GoogleAppLinkButtonProps {
  href: string;
  displayText?: string;
  hasApp: boolean;
  contrastColor: string;
  isHighlighted?: boolean;
}

export const GoogleAppLinkButton = ({
  href,
  displayText,
  hasApp,
  contrastColor,
  isHighlighted,
}: GoogleAppLinkButtonProps) => (
  <Flex
    position="relative"
    width="full"
    justifyContent="center"
    direction="row"
    align="center"
    mt={5}
    mb={3}
    data-highlighted={isHighlighted || undefined}
  >
    <Button
      w="90%"
      size="sm"
      variant="none"
      borderRadius="25px"
      border="1px solid"
      borderColor={isHighlighted ? HIGHLIGHT_COLOR : contrastColor}
      boxShadow={isHighlighted ? `0 0 0 1px ${HIGHLIGHT_COLOR}` : undefined}
      _hover={{ opacity: 0.7 }}
      mx="10px"
    >
      <Link
        href={href}
        isExternal
        textDecoration="none"
        _hover={{ textDecoration: 'none' }}
      >
        <Flex direction="row" alignItems="center" gap={2} color={contrastColor}>
          <CustomLinkIcon boxSize="11px" />
          <Text fontSize="12px" textStyle="headingFamilyRegularGooglePay">
            {displayText || `Open issuer's ${hasApp ? 'app' : 'website'}`}
          </Text>
        </Flex>
      </Link>
    </Button>
  </Flex>
);
